import { useEffect, useState } from 'react';
import {
  aenor_light,
  arauco_light,
  aws_light,
  corfo_light,
  ecota_light,
  ge_light,
  magical_light,
  sme_light,
  stellar_light,
  techstars_light,
  verra_light,
  aenor_dark,
  arauco_dark,
  aws_dark,
  corfo_dark,
  ecota_dark,
  ge_dark,
  magical_dark,
  sme_dark,
  stellar_dark,
  techstars_dark,
  verra_dark,
} from './alliesCard.module';
import { useTheme } from '@material-ui/core';

const AlliesCardLogic = (props) => {
  const theme = useTheme();
  const [is_light, setIsLight] = useState(theme.palette.mode === 'light');
  const DICTIONARY = {
    aenor: !is_light ? aenor_light : aenor_dark,
    arauco: !is_light ? arauco_light : arauco_dark,
    aws: !is_light ? aws_light : aws_dark,
    british: !is_light ? ge_light : ge_dark,
    corfo: !is_light ? corfo_light : corfo_dark,
    ecota: !is_light ? ecota_light : ecota_dark,
    magical: !is_light ? magical_light : magical_dark,
    sme: !is_light ? sme_light : sme_dark,
    stellar: !is_light ? stellar_light : stellar_dark,
    techstars: !is_light ? techstars_light : techstars_dark,
    verra: !is_light ? verra_light : verra_dark,
  };
  const { ally } = props;
  const [values, setValues] = useState({
    ...props,
    img: sme_light,
  });

  const setClass = () => {
    const img = DICTIONARY[ally] || sme_light;
    setValues({ ...values, img });
  };

  useEffect(() => {
    setClass();
  }, []);

  useEffect(() => {
    setClass();
  }, [is_light]);

  useEffect(() => {
    setIsLight(theme.palette.mode === 'light');
  }, [theme]);

  return {
    values,
  };
};

export default AlliesCardLogic;
